export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11892.287eaa36.jpg";